import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "../assets/i18n/en.json";
/**
 * Initializes i18next with React integration.
 */
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation,
    },
  },
  lng: "en", // Default language
  fallbackLng: "en", // Fallback language
  interpolation: {
    escapeValue: false, // React already escapes values by default
  },
});

export default i18n;
